import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'core-default-layout',
  templateUrl: './default-layout.component.html',
  styleUrls: ['./assets/scss/sb-admin/sb-admin.scss']
})
export class DefaultLayoutComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
